import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { get } from '@core/Services/ApiService'
import { HasLoggedOut, UpdateAccountBalance } from '@core/State/UserAccount/userAccountDriver'
import { useLogon } from '@core/Utils/hooks/useLogon'

export const useAccountDetailsQuery = (shouldFetch: boolean) => {
  const { isLoggedIn } = useLogon()

  return useQuery({
    queryKey: queryKeys.accountDetailsForMenu,
    queryFn: fetchAccountDetailsForMenu,
    enabled: Boolean(shouldFetch && isLoggedIn),
    staleTime: 2_000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}

// =============
// Local Helpers
// =============

type GetAccountDetailsRes = {
  accountName: string
  accountNumber: number
  balance: string
  blackBookAlertCount: number
  activeCampaignsCount: number
}

async function fetchAccountDetailsForMenu(): Promise<GetAccountDetailsRes> {
  const res = await get<GetAccountDetailsRes>({ url: '/api/account/detailsformenu' })

  if (res.accountNumber === 0) {
    HasLoggedOut()
    throw new Error('ACCOUNT_LOGGED_OUT')
  }

  const balanceCleaned = (res.balance || '').replace('$', '').replace(/,/g, '')
  UpdateAccountBalance({ balance: balanceCleaned })

  return res
}
